module.exports = __webpack_public_path__ + "img/seo_thumbnail-600x450.00775439.jpg";